import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { getCountyLoanLimits, estimateGuaranty } from 'app/gears/guarantycalculator/actions/guarantyCalculatorActions'
import { Field, reduxForm, formValueSelector, change } from 'redux-form'
import LgyInputField from 'app/components/util/lgy-input-field/LgyInputField'
import LgySelectField from 'app/components/util/lgy-select-field/LgySelectField'
import LgyFormSubmit from 'app/components/util/lgy-form-submit/LgyFormSubmit'
import { LgySubsection } from 'app/components/util/lgy-section/LgySection'
import { realNumber, nonNegative, positive, required } from 'app/utils/validations'
import stateCountyMap from '../constants/state-county-map'
import LgyField from 'app/components/util/lgy-field/LgyField'
import { formatDollars } from 'app/utils/fieldUtils'

import '../style/guaranty-calculator-gear.scss'

function getCountyLoanLimit(state, county, countyLoanLimits) {
  let limitByCounty = countyLoanLimits.find(cll => cll.state === state && cll.county === county);
  if (!limitByCounty) {
    limitByCounty = countyLoanLimits.find(cll => cll.state === 'default' && cll.county === 'default');
  }
  return limitByCounty.loanLimit;
}


// TODO: split into HOC container and UI component
function GuarantyCalculatorGear({ minMode, getCountyLoanLimits, countyLoanLimits, stateSelected, countySelected, guarantyAmount, guarantyPercent, isStateCountyValid, ...reduxFormProps }) {
  useEffect(
    () => {
      if (!countyLoanLimits || countyLoanLimits.length <= 1) {
        getCountyLoanLimits();
      }
    },
    [countyLoanLimits, getCountyLoanLimits],
  )

  const statesList = Object.keys(stateCountyMap);

  return <div className={minMode ? "guaranty-calculator usa-grid min-mode" : "guaranty-calculator usa-grid"}>
    <h1>Guaranty Percentage Calculator</h1>
    {minMode 
      ? <p>Maximize the calculator for a full calculation</p>
      : <p>This calculator is for estimation purposes only. For more accurate and detailed information, please refer to the veteran's COE record.</p>}
    <form onSubmit={reduxFormProps.handleSubmit}>
      <LgySubsection>
        <Field
          name='state'
          type='text'
          component={LgySelectField}
          label='State'
          tooltip='Select a state'
          validate={[required]}
          required
          onChange={() => { change("county", null); }}
        >
          {statesList.map(state => <option key={state} value={state}>{state}</option>)}
        </Field>

        <Field
          name='county'
          type='text'
          component={LgySelectField}
          label='County'
          tooltip='Select a county'
          validate={[required]}
          required
        >
          {stateCountyMap[stateSelected] ?
            stateCountyMap[stateSelected].map(county => <option key={county} value={county}>{county}</option>)
            : <option value='' disabled>Select state first</option>
          }
        </Field>
        <br />
        <LgyField className='guaranty-calculator-output' label={stateSelected === 'Louisiana' ? 'Parish Loan Limit' : 'County Loan Limit'}
          value={isStateCountyValid ? "$ ".concat(formatDollars(getCountyLoanLimit(stateSelected, countySelected, countyLoanLimits))) : null}
        />

        <div className='hide-when-minimized'>
          <Field
            name='previousEntitlementCharged'
            type='text'
            component={LgyInputField}
            label='Previous Entitlement Charged'
            tooltip="Entitlement used in previous loans and not restored"
            placeholder='e.g. 0'
            validate={[realNumber, nonNegative, required]}
            required
          />
        </div>

        <div className='hide-when-minimized'>
          <Field
            name='loanAmount'
            type='text'
            component={LgyInputField}
            label='Loan Amount'
            tooltip="Total amount of loan"
            placeholder='e.g. 250000'
            validate={[realNumber, positive, required]}            
            required
          />
        </div>
        <br />
        <div className='hide-when-minimized'>
          <LgyField className='guaranty-calculator-output' label='Guaranty Amount' value={reduxFormProps.valid && guarantyAmount ? "$ ".concat(formatDollars(guarantyAmount)) : null} />
        </div>

        <div className='hide-when-minimized'>
          <LgyField className='guaranty-calculator-output' label='Guaranty Percent' value={reduxFormProps.valid && guarantyPercent ? guarantyPercent + "%" : null} />
        </div>

      </LgySubsection>
      <div className='hide-when-minimized'>
        <LgyFormSubmit {...reduxFormProps}/>
      </div>
    </form>

  </div>
}

// Connect to redux form
const GuarantyCalculatorGearWithReduxForm = reduxForm({ form: 'guarantyCalculator', initialValues: { state: null, county: null, previousEntitlementCharged: null, loanAmount: null } })(GuarantyCalculatorGear)

const selector = formValueSelector('guarantyCalculator')

const mapDispatchToProps = {
  getCountyLoanLimits,
  estimateGuaranty,
  onSubmit: estimateGuaranty
}

const mapStateToProps = state => ({
  ...state.guarantyCalculatorState,
  stateSelected: selector(state, 'state'),
  countySelected: selector(state, 'county'),
  isStateCountyValid: selector(state, 'state') && selector(state, 'county')
})

// Connect to redux
export default connect(mapStateToProps, mapDispatchToProps)(GuarantyCalculatorGearWithReduxForm)